const permissions = {
  organizationCatalog: 'MB005',
  organizationAdd: 'MB006',
  organizationEdit: 'MB007',
  organizationDelete: 'MB008',
  organizationApiKeysRead: 'MB021',
  organizationApiKeysCreate: 'MB022',
  organizationApiKeysEdit: 'MB023',
  organizationApiKeysDeactivate: 'MB024'
};

export default permissions;
